import { useState, createContext } from 'react';
export const SidebarContext = createContext();

export const SidebarContextProvider = ({ children }) => {
  const [styledParagraph, setStyledParagraph] = useState(null);
  const [draftComment, setDraftComment] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(0);
  const [activeComment, setActiveComment] = useState(null);
  const [activeTagsTab, setActiveTagsTab] = useState('taxonomy'); // 'taxonomy' | 'allTags' | 'tagInfo'

  return (
    <SidebarContext.Provider
      value={{
        draftComment,
        setDraftComment,
        styledParagraph,
        setStyledParagraph,
        isSidebarOpen,
        setIsSidebarOpen,
        activeComment,
        setActiveComment,
        activeTagsTab,
        setActiveTagsTab,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
